export default __webpack_public_path__ + "media/images/mailer/icon_file_download-fb5f9be9fd8e11726c3b3a1d47e72717.png";